export default __webpack_public_path__ + "static/media/preview.9fe201a3.svg";